export default "__VITE_ASSET__Di8h$yxd__"